import React from 'react';

const SMSSvg = (
  props: React.SVGAttributes<SVGElement> & { color?: string },
): React.ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.09365 6.35166C7.73428 5.01729 9.71396 4.3501 12.0327 4.3501C14.3515 4.3501 16.3312 5.01729 17.9718 6.35166C19.6124 7.68603 20.4327 9.29385 20.4327 11.1751C20.4327 13.0563 19.6124 14.6642 17.9718 15.9985C16.3312 17.3329 14.3515 18.0001 12.0327 18.0001C11.0046 18.0001 9.9874 17.847 8.98115 17.5407C7.55928 18.547 6.03896 19.0501 4.42021 19.0501C4.07021 19.0501 3.82959 18.886 3.69834 18.5579C3.56709 18.2517 3.61084 17.9782 3.82959 17.7376C3.87334 17.6938 3.97178 17.5845 4.1249 17.4095C4.2999 17.2126 4.50771 16.9173 4.74834 16.5235C5.01084 16.1079 5.21865 15.7032 5.37178 15.3095C4.2124 14.0845 3.63271 12.7063 3.63271 11.1751C3.63271 9.29385 4.45303 7.68603 6.09365 6.35166ZM12.0327 16.4251C13.914 16.4251 15.5218 15.911 16.8562 14.8829C18.1905 13.8548 18.8577 12.6188 18.8577 11.1751C18.8577 9.73135 18.1905 8.49541 16.8562 7.46728C15.5218 6.43916 13.914 5.9251 12.0327 5.9251C10.1515 5.9251 8.54365 6.43916 7.20928 7.46728C5.8749 8.49541 5.20771 9.73135 5.20771 11.1751C5.20771 12.2907 5.64521 13.3079 6.52021 14.2267L7.17646 14.9485L6.84834 15.8673C6.67334 16.3048 6.45459 16.7532 6.19209 17.2126C6.84834 16.9938 7.47178 16.6657 8.0624 16.2282L8.71865 15.8017L9.47334 16.0313C10.3046 16.2938 11.1577 16.4251 12.0327 16.4251Z"
      fill={props.color || '#001238'}
    />
  </svg>
);

export default SMSSvg;
